import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f2f9143"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "spinner" }
const _hoisted_2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "22.857142857142858 22.857142857142858 45.714285714285715 45.714285714285715",
  class: "svg",
  style: {"transform":"rotate(0deg)"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  fill: "transparent",
  cx: "45.714285714285715",
  cy: "45.714285714285715",
  r: "20",
  "stroke-width": "5.714285714285714",
  "stroke-dasharray": "125.664",
  "stroke-dashoffset": "125.66370614359172px",
  class: "circle"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    appear: "",
    name: "fade"
  }, {
    default: _withCtx(() => [
      (_ctx.isVisible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "c-loading",
            style: _normalizeStyle({ zIndex: _ctx.zIndex })
          }, [
            _createElementVNode("div", _hoisted_1, [
              (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
            ])
          ], 4))
        : _createCommentVNode("", true)
    ], undefined, true),
    _: 1
  }))
}